import React from "react";
import styled from "@emotion/styled";
import { Toggle } from "@kompare/kompare-ui-library";
import { Divider, Flex, Grid, Label, Tag, Text } from 'src/components';
import { colors } from 'src/theme';
import { formatNumber, i18n, mediaQuery } from "src/common";
import { Card } from "./card";

const CardContainerUp = styled.div({
  padding: '16px'
})

const CardContainerDown = styled.div({
  padding: '20px',
  backgroundColor: colors.primary,
  borderRadius: '0 0 12px 12px'
})

const Logo = styled.img({
  maxHeight: '48px',
  minHeight: '26px',
  maxWidth: '164px'
})

const GridStyle = styled(Grid)({
  gridTemplateColumns: '1fr auto',

  [mediaQuery('mobile')]: {
    gridTemplateColumns: '1fr auto auto',
  },
})

const LabelStyle = styled(Label)({
  display: 'none',

  [mediaQuery('mobile')]: {
    display: 'block',
  },
})

interface OfferFinalCardProps {
  offer: any;
  yearToggle?: boolean;
  className?: string;
  handleYearToggle?: () => void;
  yearToggleDisabled?: boolean;
}

export const OfferFinalCard = ({ offer, yearToggle, className, handleYearToggle, yearToggleDisabled = false }: OfferFinalCardProps) => {
  const discountPercentage = ((offer.total.generalTransferWithInstallments - offer.total.generalTransfer) / offer.total.generalTransferWithInstallments) * 100;
  const roundedDiscountPercentage = Math.round(discountPercentage); // Zaokruživanje na više bez decimalnih mjesta

  // Helper za provjeru je li modifier validan i različit od 0
  const isModifierApplied = (modifier: any) => {
    if (!modifier) return false;
    if (typeof modifier.amount !== 'number') return false;
    return modifier.amount !== 0;
  };

  const hasActiveModifiers = 
    isModifierApplied(offer.supplementary.voucherPriceChangeModifier) ||
    isModifierApplied(offer.supplementary.voucherPriceModifier) ||
    isModifierApplied(offer.supplementary.priceChangeModifier);

  return (
    <Card padding='0px' radius={12} className={className}>
      <CardContainerUp>
        <Flex gap={16} align='center'>
          <Logo src={offer.supplementary.logoUrl} alt="logo" />
          {/* <Flex vertical gap={4}>
            <Text type='base' bold>{offer.supplementary.brandName}</Text>
            <Label type='medium'>{offer.supplementary.label}</Label>
          </Flex> */}
        </Flex>
        <Divider dashed gap={'8px 16px'} />
        <Flex vertical gap={16}>
          <GridStyle columnGap={8} align='center'>
            <LabelStyle type='small'>{offer.supplementary.label}</LabelStyle>
            <Flex gap={4} align='center'>
              <Text type='tiny'>{i18n.t(`components.cards.offerHeaderCard.${offer.supplementary.brandCode === 'groupama' ? 'totalYearlyGeneral' : 'totalYearly'}`)}</Text>
              {roundedDiscountPercentage > 0 && <Tag value={`${roundedDiscountPercentage}% uštede`} background={colors.success2} />}
            </Flex>
            <Toggle checked={yearToggle} onChange={handleYearToggle} labelMarginBottom="0px" disabled={yearToggleDisabled} />
          </GridStyle>
          {/* <Flex justify='space-between' gap={8} align='center'>
            <Text type='tiny'>kompare.hr Superpopust</Text>
            <Toggle checked disabled labelMarginBottom="0px" />
          </Flex> */}
          {hasActiveModifiers && <Divider dashed />}
          {isModifierApplied(offer.supplementary.voucherPriceChangeModifier) &&
            <Flex justify='space-between' gap={8} align='center'>
              <Flex gap={4} align='center'>
                <Text type='tiny'>{offer.supplementary.voucherPriceChangeModifier?.description || i18n.t('components.cards.offerHeaderCard.voucherCode')}</Text>
                <Tag value={offer.supplementary.voucherPriceChangeModifier?.code} background={colors.success2} />
              </Flex>
              <Text type='tiny' color={colors.success} bold>{offer.supplementary.voucherPriceChangeModifier?.type === 'fixed' ? `${formatNumber(offer.supplementary.voucherPriceChangeModifier?.amount)}€` : `${offer.supplementary.voucherPriceChangeModifier?.amount}%`}</Text>
            </Flex>
          }
          {isModifierApplied(offer.supplementary.voucherPriceModifier) &&
            <Flex justify='space-between' gap={8} align='center'>
              <Text type='tiny'>{i18n.t('components.cards.offerHeaderCard.simpleVoucherCode')}</Text>
              <Text type='tiny' color={colors.success} bold>{formatNumber(offer.supplementary.voucherPriceModifier?.amount)}€</Text>
            </Flex>
          }
          {isModifierApplied(offer.supplementary.priceChangeModifier) &&
            <Flex justify='space-between' gap={8} align='center'>
              <Text type='tiny'>{offer.supplementary.priceChangeModifier?.description}</Text>
              <Text type='tiny' color={colors.success} bold>{offer.supplementary.priceChangeModifier?.type === 'fixed' ? `${formatNumber(offer.supplementary.priceChangeModifier?.amount)}€` : `${offer.supplementary.priceChangeModifier?.amount}%`}</Text>
            </Flex>
          }
        </Flex>
      </CardContainerUp>
      <CardContainerDown>
        <Flex gap={12} vertical>
          <Flex gap={16} align='center' justify='space-between'>
            <Text type='base' bold color={colors.text7}>{'Za platiti'}</Text>
            <Flex vertical align='flex-end'>
              <Text type='large' bold color={colors.text7}>{`${yearToggle ? formatNumber(offer.total.generalTransfer) : formatNumber(offer.total.generalTransferWithInstallments / 12)}€`}</Text>
              <Text type='tiny' color={colors.text7}>{yearToggle ? 'jednokratno' : 'mjesečno'}</Text>
            </Flex>
          </Flex>
          <Text type='micro' color={colors.text7}>{'Cijena vrijedi samo za kupovinu na kompare.hr'}</Text>
        </Flex>

      </CardContainerDown>
    </Card>
  )
};